import * as React from 'react';
import TwoColRow from './TwoColRow';
const PaymentDefaultSummary = ({ value, i18n, formatDate, formatNumber }) => {
    let paymentDefaultsAndIndividualPayments = [
        ...value.paymentDefaults,
        ...value.individualPayments
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(TwoColRow, { label: i18n('readreport.content.paymentDefault.overview.amount.caption'), value: value.paymentDefaults.length + value.individualPayments.length }),
        paymentDefaultsAndIndividualPayments.length > 0 ? (React.createElement(TwoColRow, { label: i18n('readreport.content.paymentDefault.overview.sum.caption'), value: formatNumber(paymentDefaultsAndIndividualPayments
                .map(item => {
                return item.amount;
            })
                .reduce((previousValue, currentValue) => {
                return previousValue + currentValue;
            })) })) : null,
        React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('stateauthority.Swedish-Enforcement-Authority')} (${formatDate(value.verificationDate)})` })));
};
export default PaymentDefaultSummary;
